module.exports = __webpack_public_path__ + "static/img/logo.9897c8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zbqfBrand/logo.png
// module id = RhWo
// module chunks = 0